<template>
  <ODialog ref="dialog" :maxWidth="600" hideWhenLoading>
    <v-card v-if="row != null">
      <ODialogBar title="Editar Organização" @close="dismiss" />
      <v-card-text class="pa-3 maxh">
        <v-form ref="theForm" v-model="isValid">
          <div class="d-flex flex-wrap">
            <OTextField
              class="w-1/2 pa-3"
              v-model="row.name"
              label="Código (alfanumérico)"
            />

            <OTextField class="w-1/2 pa-3" v-model="row.label" label="Label" />

            <OTextarea
              class="w-full pa-3"
              v-model="urls"
              label="URLs (1 por linha, primária no topo)"
              :rows="3"
            />

            <div class="w-1/2 pa-3 d-flex items-end justify-stretch">
              <OTextField
                class="grow-1"
                v-model="row.extraInfo.internalIp"
                label="IP (interno)"
              />
              <v-btn
                icon
                title="Primeiro IP disponível a partir de 10.0.0.101"
                @click="findIp"
              >
                <v-icon>mdi-flash</v-icon>
              </v-btn>
            </div>

            <div class="w-1/2 pa-3 d-flex items-end justify-stretch">
              <OTextField
                class="grow-1"
                v-model="row.extraInfo.internalPort"
                label="Porta (interna)"
              />
              <v-btn
                icon
                title="Máx porta atual +2"
                @click="findPort"
              >
                <v-icon>mdi-flash</v-icon>
              </v-btn>
            </div>

            <div class="w-full pa-3 d-flex items-end justify-stretch">
              <OTextField
                class="grow-1"
                v-model="row.database"
                label="Database"
              />
              <v-btn icon @click="makeDatabase">
                <v-icon>mdi-flash</v-icon>
              </v-btn>
            </div>

            <div class="w-full pa-3 d-flex items-end justify-stretch">
              <OTextField
                class="grow-1 monospace-input"
                v-model="row.returnToken"
                label="Return Token"
              />
              <v-btn icon @click="generateToken">
                <v-icon>mdi-flash</v-icon>
              </v-btn>
            </div>

            <div class="w-full pa-3">
              <OTagsInput
                v-model="row.extraInfo.tags"
                :items="allTags"
                label="Tags"
              />
            </div>
          </div>
        </v-form>
      </v-card-text>
      <ODialogButtons
        class="pa-6"
        @cancel="dismiss"
        txtApply="Salvar"
        @apply="apply"
      />
    </v-card>
  </ODialog>
</template>

<script>
import { Org } from '@/models'
import utils from 'oderon-commons/src/utils'
import randomstring from 'randomstring'
import OTagsInput from 'oderon-vue/cpts/OTagsInput.vue'

export default {
  components: { OTagsInput },
  data() {
    return {
      id: null,
      isValid: false,
      row: null,
      urls: null,
      allTags: ['PRD', 'V3', 'V4', 'Checklist', 'OLD', 'HLG']
    }
  },
  watch: {
    'row.database'(x) {
      if (utils.isEmpty(x)) return null
      if (!x.startsWith('mysql://')) this.row.database = 'mysql://' + x
    }
  },
  methods: {
    open(id) {
      this.id = id
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },
    async fetchData() {
      let row = await Org.findById(this.id)
      if (row.extraInfo == null) row.extraInfo = {}

      let aliases = row.extraInfo.aliases
      if (aliases == null) aliases = []

      this.urls = utils.joinNonBlank([row.url, ...aliases])
      this.row = row
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    },

    async apply() {
      this.$refs.theForm.validate()
      if (this.isValid) {
        let urls = this.urls.split('\n').map((x) => x.trim())
        urls = urls.filter((x) => !utils.isEmpty(x))

        this.row.url = urls[0]
        this.row.extraInfo.aliases = urls.slice(1)

        await this.$refs.dialog.$loading(async () => {
          await Org.save(this.row)
          this.$snack('Salvo com sucesso')
          this.$refs.dialog.$apply(true) // reload na tela de baixo
        })
      }
    },

    generateToken() {
      this.row.returnToken = randomstring.generate(16)
    },

    async findIp() {
      let rows = await Org.findAll()
      let ips = rows.map((r) => {
        let ip = r.extraInfo && r.extraInfo.internalIp
        if (ip == null) return null
        return parseInt(ip.split('.')[3])
      })

      let max = 103
      while (max <= 255) {
        if (ips.includes(max)) max = max + 1
        else break
      }

      this.$set(this.row.extraInfo, 'internalIp', `10.0.0.${max}`)
    },

    async findPort() {
      let rows = await Org.findAll()
      let maxPort = 8050

      for ( let r of rows ) {
        if ( r.extraInfo && r.extraInfo.internalPort ) {
          let p = parseInt(r.extraInfo.internalPort)
          if ( maxPort == null || p > maxPort ) maxPort = p
        }
      }

      maxPort = maxPort + 2

      this.$set(this.row.extraInfo, 'internalPort', maxPort)
    },

    makeDatabase() {
      let nameWithoutEnv = this.row.name.replace(/(dev$|hlg$)/, '')

      let isPrd = utils.hasTag(this.row.extraInfo, 'PRD')
      let schema = isPrd
        ? `dsh_${nameWithoutEnv}_prd`
        : `dsh_${nameWithoutEnv}_hlg`

      this.row.database = `mysql://${schema}:SENHA@dbX.odvpc/${schema}`
    }
  }
}
</script>

<style scoped>
.maxh {
  max-height: calc(100vh - 64px - 64px - 128px);
  overflow-y: auto;
}
</style>
